
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SCHOOL_CANCEL_REASONS } from '@/utils/constants';
import ReasonSelect from './ReasonSelect.vue';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<CancelSchoolOrderModal>({
	components: {
		ReasonSelect,
		StandardModal
	}
})
export default class CancelSchoolOrderModal extends Vue {
	@Prop({ type: Boolean, required: true }) private loading!: boolean;
	@Prop({ type: String, required: true }) private text!: string;

	private schoolCancelReasons: string[] = SCHOOL_CANCEL_REASONS;
	private reason: { value: string; note: string; } = { value: '', note: '' };
}
